import React from 'react';
import { Plus } from 'lucide-react';
import ProjectRow from './ProjectRow';
import Reveal from './Reveal';

const ProjectsPage = ({ projects, isAuthenticated, onEditProject, onDeleteProject, onOpenNewProject }) => {
  return (
    <div className="page py-12 md:py-16">
      <header className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:justify-between">
        <h1 className="page-title">Projects</h1>
        {isAuthenticated && (
          <button type="button" onClick={onOpenNewProject} className="btn-primary">
            <Plus size={18} strokeWidth={1.75} />
            Add Project
          </button>
        )}
      </header>

      {projects.length === 0 ? (
        <div className="mt-12 max-w-xl rounded-xl bg-slate-900 p-8 ring-1 ring-white/10">
          <h2 className="text-xl font-semibold text-slate-50">No Projects Yet</h2>
          <p className="mt-2 text-slate-400">
            {isAuthenticated
              ? "Use 'Add Project' to showcase your first project."
              : 'Check back soon for new projects!'}
          </p>
        </div>
      ) : (
        <div className="mt-8 divide-y divide-white/5 border-t border-white/5">
          {projects.map((project) => (
            <Reveal key={project.id}>
              <ProjectRow
                project={project}
                titleAs="h2"
                onEdit={isAuthenticated ? onEditProject : undefined}
                onDelete={isAuthenticated ? onDeleteProject : undefined}
              />
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsPage;
